import { render, staticRenderFns } from "./atlas.vue?vue&type=template&id=b639eb3a&scoped=true&"
import script from "./atlas.vue?vue&type=script&lang=js&"
export * from "./atlas.vue?vue&type=script&lang=js&"
import style0 from "./atlas.vue?vue&type=style&index=0&id=b639eb3a&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b639eb3a",
  null
  
)

export default component.exports